import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout from './components/layout/DashboardLayout';
import ProtectedRoute from './components/ProtectedRoute';
import { RoleProvider } from './contexts/RoleContext';
import { TenantProvider } from './contexts/TenantContext';
import GlobalVoiceProvider from './components/GlobalVoiceProvider';
import { IS_INTERNAL } from './lib/tenantMode';

const DashboardPage      = lazy(() => import('./pages/DashboardPage'));
const ProfilesPage       = lazy(() => import('./pages/ProfilesPage'));
const JobsPage           = lazy(() => import('./pages/JobsPage'));
const ConfigPage         = lazy(() => import('./pages/ConfigPage'));
const PartsPage          = lazy(() => import('./pages/PartsPage'));
const SalesPage          = lazy(() => import('./pages/SalesPage'));
const ReportsPage        = lazy(() => import('./pages/ReportsPage'));
const DispatchPage       = lazy(() => import('./pages/DispatchPage'));
const DevPage            = lazy(() => import('./pages/DevPage'));

function PageFallback() {
  return (
    <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ width: 28, height: 28, border: '3px solid #e5e7eb', borderTopColor: '#111', borderRadius: '50%', animation: 'spin 0.7s linear infinite' }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <TenantProvider>
        <RoleProvider>
          <GlobalVoiceProvider>
            <ProtectedRoute>
              <DashboardLayout>
                <Suspense fallback={<PageFallback />}>
                  <Routes>
                  <Route path="/"          element={<DashboardPage />} />
                  <Route path="/chat"      element={<Navigate to="/" replace />} />
                  <Route path="/jobs"      element={<JobsPage />} />
                  <Route path="/customers" element={<Navigate to="/profiles" replace />} />
                  <Route path="/profiles"  element={<ProfilesPage />} />
                  <Route path="/parts"     element={<PartsPage />} />
                  <Route path="/dispatch"  element={<DispatchPage />} />
                  <Route path="/sales"     element={<SalesPage />} />
                  <Route path="/reports"   element={<ReportsPage />} />
                  <Route path="/field"     element={<Navigate to="/dispatch" replace />} />
                  <Route path="/config"    element={<ConfigPage />} />
                  <Route path="/spell"          element={<Navigate to="/" replace />} />
                  <Route path="/command-center" element={<Navigate to="/" replace />} />
                  {/* Internal-only routes — hidden in hosted-tenant builds */}
                  {IS_INTERNAL && <Route path="/dev"       element={<DevPage />} />}
                  </Routes>
                </Suspense>
              </DashboardLayout>
            </ProtectedRoute>
          </GlobalVoiceProvider>
        </RoleProvider>
      </TenantProvider>
    </BrowserRouter>
  );
}

export default App;
